module.exports = __webpack_public_path__ + "img/智能实训-图片2.ce10aee1.png";